// 导出配置的路由器
export default [
  {
    path: '/error',
    component: () => import('@/layout/index'),
    redirect: 'error/404',
    hidden: true,
    meta: {
      title: '错误页面',
      icon: '404'
    },
    children: [
      {
        path: '404',
        component: () => import('@/module/error-page/page/404'),
        meta: {title: '404页面'}
      }
    ]
  },
  {
    path: '/404',
    hidden: true,
    component: () => import('@/module/error-page/page/404'),
    meta: {title: '404页面'}
  },
  {
    path: '/401',
    hidden: true,
    component: () => import('@/module/error-page/page/401'),
    meta: {title: '401页面'}
  }
]



// WEBPACK FOOTER //
// ./src/module/error-page/router/index.js